/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ProductRegisterSkuResult } from './ProductRegisterSkuResult';
import {
    ProductRegisterSkuResultFromJSON,
    ProductRegisterSkuResultFromJSONTyped,
    ProductRegisterSkuResultToJSON,
    ProductRegisterSkuResultToJSONTyped,
} from './ProductRegisterSkuResult';

/**
 * 
 * @export
 * @interface ProductRegisterResVo
 */
export interface ProductRegisterResVo {
    /**
     * SPU编码
     * @type {string}
     * @memberof ProductRegisterResVo
     */
    spuCode?: string;
    /**
     * 商品名称
     * @type {string}
     * @memberof ProductRegisterResVo
     */
    productName?: string;
    /**
     * 
     * @type {Array<ProductRegisterSkuResult>}
     * @memberof ProductRegisterResVo
     */
    skus?: Array<ProductRegisterSkuResult>;
}

/**
 * Check if a given object implements the ProductRegisterResVo interface.
 */
export function instanceOfProductRegisterResVo(value: object): value is ProductRegisterResVo {
    return true;
}

export function ProductRegisterResVoFromJSON(json: any): ProductRegisterResVo {
    return ProductRegisterResVoFromJSONTyped(json, false);
}

export function ProductRegisterResVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProductRegisterResVo {
    if (json == null) {
        return json;
    }
    return {
        
        'spuCode': json['spuCode'] == null ? undefined : json['spuCode'],
        'productName': json['productName'] == null ? undefined : json['productName'],
        'skus': json['skus'] == null ? undefined : ((json['skus'] as Array<any>).map(ProductRegisterSkuResultFromJSON)),
    };
}

export function ProductRegisterResVoToJSON(json: any): ProductRegisterResVo {
    return ProductRegisterResVoToJSONTyped(json, false);
}

export function ProductRegisterResVoToJSONTyped(value?: ProductRegisterResVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'spuCode': value['spuCode'],
        'productName': value['productName'],
        'skus': value['skus'] == null ? undefined : ((value['skus'] as Array<any>).map(ProductRegisterSkuResultToJSON)),
    };
}

